<script>
	import { onMount } from 'svelte';
	import { orders } from './../stores/orders.js';

    let ordersData=[];
    onMount(async () => {
        orders.getOrders().then((res)=>{
            ordersData =res;
            console.log("ordersData:::"+JSON.stringify(ordersData))
        })
    })

</script>

<div class="row">
    <div class="col-sm-12">
        <div class="card">
            <div class="card-body">
                <!-- title -->
                <div class="d-md-flex align-items-center">
                    <div>
                        <h4 class="card-title">
                            Enquiry List
                        </h4>
                        <p class="card-subtitle">
                            Users who requested for Quotation
                        </p>
                    </div>
                    <div class="ml-auto">
                        <div class="dl">
                            <select class="custom-select">
                                <option
                                    value="0"
                                    selected="">
                                    Monthly
                                </option>
                                <option value="1">
                                    Daily
                                </option>
                                <option value="2">
                                    Weekly
                                </option>
                                <option value="3">
                                    Yearly
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <!-- title -->
            </div>
            <div class="table-responsive">
                <table class="table v-middle">
                    <thead>
                        <tr class="bg-light">
                            <th class="border-top-0">
                                User Name
                            </th>
                            <th class="border-top-0">
                                Email
                            </th>
                            <th class="border-top-0">
                                Paper Type
                            </th>
                            <th class="border-top-0">
                                Art Type
                            </th>
                            <th class="border-top-0">
                                Delivery Area
                            </th>
                            <th class="border-top-0">
                                Delivery Date
                            </th>
                            <th class="border-top-0">
                                Order Status
                            </th>
                            <th class="border-top-0">
                                Art Price
                            </th>
                            <th class="border-top-0">
                                Frame Price
                            </th>
                            <th class="border-top-0">
                                Gift Price
                            </th>
                            <th class="border-top-0">
                                Delivery Price
                            </th>
                            <th class="border-top-0">
                                Total Price
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each ordersData as order}
                            
                        <tr>
                            <td>
                                <div
                                    class="d-flex align-items-center">
                                    <div class="m-r-10">
                                        <!-- svelte-ignore a11y-missing-attribute -->
                                        <!-- <img
                                            class="btn btn-circle btn-info" src={order.clientprofile} /> -->
                                          <!-- <img src="{order.clientprofile}" /> -->
                                          
                                          
                                         
                                          <!-- svelte-ignore missing-declaration -->
                                          <!-- svelte-ignore a11y-img-redundant-alt -->
                                          <!-- <img
                                          align="center" alt="profile" border="0"
                                          class="center fixedwidth"
                                          src={order.clientprofile}
                                          style="text-decoration: none; -ms-interpolation-mode: bicubic; height: auto; border-radius: 50%; border: 0; width: 100%; max-width: 135px; display: block;"
                                          title="I'm an image" width="150" />   -->
                                    </div>
                                    <div class="">
                                        <h4
                                            class="m-b-0 font-16">
                                            {order.clientname}
                                        </h4>
                                    </div>
                                </div>
                            </td>
                            <td>{order.email}</td>
                            <td>{order.papertype}<br/><span class="badge badge-secondary">with {order.additionalface} Additional Face</span></td>
                            <td>{order.arttype}</td>
                            <td>{order.deliveryarea}</td>
                            <td>21-03-2021</td>
                            <td><span
                                class="font-w600 text-warning">{order.orderstatus}</span></td>
                            <td>₹ {order.artprice}</td>
                            <td>₹ {order.frameprice}</td>
                            <td>₹ {order.giftprice}</td>
                            <td>₹ {order.deliveryprice}</td>
                            <td>
                                <h5 class="m-b-0">
                                    ₹ {order.totalamount}
                                </h5>
                            </td>
                        </tr>

                        {/each}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>